import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { BASE_URL } from '../apiConfig'

// export const fetchInventory = createAsyncThunk(
//   'fetchInventory',
//   async ({ type, jwtBearer }) => {
//     const response = await fetch(`${BASE_URL}inventory/get/?type=${type}`, {
//       headers: {
//         Authorization: `Bearer ${jwtBearer}` // Include the bearer token in the request header
//       }
//     })
//     return response.json()
//   }
// )

export const fetchInventory = createAsyncThunk(
  'fetchInventory',
  async ({ type, jwtBearer }, { rejectWithValue }) => {
    try {
      const response = await fetch(`${BASE_URL}inventory/get/?type=${type}`, {
        headers: {
          Authorization: `Bearer ${jwtBearer}`
        }
      });

      if (!response.ok) {
        if (response.status === 401) {
          window.location.reload();
        }
        const errorText = await response.text();
        throw new Error(`Network error: ${response.status} ${errorText}`);
      }

      return await response.json();
    } catch (error) {
      console.error("Fetch error:", error);
      return rejectWithValue(error.message);
    }
  }
);


const inventorySlice = createSlice({
  name: 'inventory',
  initialState: {
    isLoading: false,
    data: null,
    isError: false
  },
  extraReducers: builder => {
    builder.addCase(fetchInventory.pending, (state, action) => {
      state.isLoading = true
    })
    builder.addCase(fetchInventory.fulfilled, (state, action) => {
      state.isLoading = false
      state.data = action.payload
    })
    builder.addCase(fetchInventory.rejected, (state, action) => {
      console.log('Error', action.payload)
      state.isError = true
    })
  }
})

export default inventorySlice.reducer
